import React, { useEffect, useRef, useState } from 'react';

// A small styled replacement for <select> (the browser's own list can't be styled): a button that opens a list of options.
//   options [{ value, label }]   value   onChange(value)   label = accessible name of the button
export default function Dropdown({ options, value, onChange, label }) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const box = useRef(null);
  const selected = options.find((o) => o.value === value) || options[0];

  useEffect(() => {
    const away = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', away);
    return () => document.removeEventListener('mousedown', away);
  }, []);

  const show = () => { setActive(Math.max(0, options.findIndex((o) => o.value === value))); setOpen(true); };
  const choose = (o) => { onChange(o.value); setOpen(false); };

  const onKeyDown = (e) => {
    if (e.key === 'Escape') return setOpen(false);
    if (!open) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); show(); }
      return undefined;
    }
    if (e.key === 'ArrowDown') { e.preventDefault(); return setActive((a) => Math.min(options.length - 1, a + 1)); }
    if (e.key === 'ArrowUp') { e.preventDefault(); return setActive((a) => Math.max(0, a - 1)); }
    if (e.key === 'Enter' && active >= 0) { e.preventDefault(); return choose(options[active]); }
    return undefined;
  };

  return (
    <div className="dd" ref={box}>
      <button type="button" className="dd-btn" aria-haspopup="listbox" aria-expanded={open} aria-label={label}
        onClick={() => (open ? setOpen(false) : show())} onKeyDown={onKeyDown}>
        <span>{selected?.label}</span>
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
      </button>
      {open && (
        <ul className="dd-menu" role="listbox" aria-label={label}>
          {options.map((o, i) => (
            <li key={o.value} role="option" aria-selected={o.value === value}>
              <button type="button" className={`${o.value === value ? 'on' : ''}${i === active ? ' hot' : ''}`} onMouseEnter={() => setActive(i)} onClick={() => choose(o)}>
                <span>{o.label}</span>
                {o.value === value && <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" /></svg>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
